"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants = __importStar(require("./constants"));
const SearchBuilder_1 = __importDefault(require("./SearchBuilder"));
class SearchJSONBuilder extends SearchBuilder_1.default {
    // --------------------------------- public methods ------------------------------------------------------------------
    getJSON() {
        return {
            [constants.SEARCH_QUERY]: this.getSearchTerm(),
            [constants.SEARCH_FILTERS]: this.getFilters(),
            [constants.SEARCH_SOURCE]: this.getSource(this.props.config[constants.GuiSource]),
            [constants.SEARCH_COLLAPSE]: this.getCollapse(),
            [constants.SEARCH_AGGREGATIONS]: this.getAggregations(this.props.config[constants.GuiAggregations]),
            [constants.SEARCH_SORT]: this.getSort(this.props.config[constants.GuiSort]),
            [constants.SEARCH_SIZE]: this.getSize(),
        };
    }
    // --------------------------------- private methods -----------------------------------------------------------------
    getSearchTerm() {
        const fields = this.getFields();
        if (fields.length > 0 || this.props.states.query !== '') {
            return {
                [constants.SEARCH_QUERY_TERM]: this.props.states.query !== '' ? this.props.states.query : undefined,
                [constants.SEARCH_QUERY_FIELDS]: fields.length > 0 ? fields : undefined,
            };
        }
        else {
            return undefined;
        }
    }
    getFields() {
        return (this.props.config[constants.GuiContainer][constants.GuiFields] || [])
            .map(f => ({
            [constants.SEARCH_FIELDS_FIELD]: f,
        }))
            .concat((this.props.config[constants.GuiBoost] || []).map((b) => ({
            [constants.SEARCH_FIELDS_FIELD]: b[constants.GuiTarget],
            [constants.SEARCH_FIELDS_BOOST]: b[constants.GuiValue],
        })));
    }
    getFilters() {
        const filters = this.getVisibleFilters().concat(this.getCustomFilters());
        return filters.length > 0 ? filters : undefined;
    }
    getVisibleFilters() {
        return (this.props.config[constants.GuiGroups] || [])
            .flatMap((g) => g[constants.GuiProperties])
            .filter(p => p[constants.GuiTarget] !== '')
            .map((p) => ({
            [constants.SEARCH_FILTERS_FIELD]: this.getPropertyField(p),
            [constants.SEARCH_FILTERS_VALUES]: this.getStateFilterValues(p, !!p[constants.GuiVisible]),
            [constants.SEARCH_FILTERS_OPERATOR]: p[constants.GuiCondition],
        }))
            .filter(f => f[constants.SEARCH_FILTERS_VALUES].length > 0);
    }
    getCustomFilters() {
        return Object.entries(this.props.states.customFilters)
            .flatMap(([id, cf]) => cf)
            .filter(f => f.key && f.values.length > 0)
            .map(cf => ({
            [constants.SEARCH_FILTERS_FIELD]: cf.key,
            [constants.SEARCH_FILTERS_VALUES]: cf.values,
        }));
    }
    getSource(prop) {
        if (prop) {
            return prop[constants.GuiFields];
        }
        else {
            return undefined;
        }
    }
    getAggregations(prop) {
        if (prop) {
            return prop[constants.GuiFields].map((f) => {
                if (typeof f === 'string') {
                    const field = f;
                    return {
                        [constants.SEARCH_AGGREGATION_NAME]: field,
                        [constants.SEARCH_AGGREGATION_FIELD]: field,
                    };
                }
                else {
                    const aggregation = f;
                    return {
                        [constants.SEARCH_AGGREGATION_NAME]: aggregation[constants.GuiName],
                        [constants.SEARCH_AGGREGATION_FIELD]: aggregation[constants.GuiField],
                        [constants.SEARCH_AGGREGATION_TERM]: aggregation[constants.GuiTerm],
                        [constants.SEARCH_AGGREGATION_INCLUDE]: aggregation[constants.GuiInclude],
                        [constants.SEARCH_AGGREGATION_EXCLUDE]: aggregation[constants.GuiExclude],
                    };
                }
            });
        }
        else {
            return undefined;
        }
    }
    getCollapse() {
        const collapse = this.props.config[constants.GuiCollapse];
        if (collapse) {
            return {
                field: collapse[constants.GuiField],
                innerHits: this.getInnerHits(collapse),
            };
        }
        else {
            return undefined;
        }
    }
    getInnerHits(collapse) {
        const inner = collapse[constants.GuiInnerHits];
        if (inner) {
            return inner[constants.GuiHits].map((hit) => {
                const source = hit[constants.GuiSource];
                const size = hit[constants.GuiSize];
                return {
                    [constants.SEARCH_COLLAPSE_INNER_HITS_NAME]: hit[constants.GuiName],
                    [constants.SEARCH_COLLAPSE_INNER_HITS_SOURCE]: source ? source[constants.GuiFields] : undefined,
                    [constants.SEARCH_COLLAPSE_INNER_HITS_SORT]: this.getSort(hit[constants.GuiSort]),
                    [constants.SEARCH_COLLAPSE_INNER_HITS_SIZE]: size ? size[constants.GuiValue] : undefined,
                };
            });
        }
        else {
            return undefined;
        }
    }
    getSort(sort) {
        return sort
            ? sort[constants.GuiOrdering].map(s => ({
                [constants.SEARCH_SORT_FIELD]: s[constants.GuiField],
                [constants.SEARCH_SORT_DIRECTION]: s[constants.GuiOrder] || 'asc',
            }))
            : undefined;
    }
    getSize() {
        const size = this.props.config[constants.GuiSize];
        return size ? size[constants.GuiValue] : undefined;
    }
}
exports.default = SearchJSONBuilder;
